import { emitFrontendDiagnostic, frontendDiagnosticsEvents } from '@emporion/ui'
import { STOREFRONT_RUNTIME_ERROR_KEY } from './storefront-runtime-contract'
import { normalizeStorefrontBlockProps } from './blockContract'
import type { BlockInstance } from './types'

export const logStorefrontRuntimeEvent = (params: {
  level: 'info' | 'warn' | 'error'
  event: string
  message: string
  context?: Record<string, unknown>
}) => {
  emitFrontendDiagnostic({
    app: 'shop',
    level: params.level,
    event: params.event,
    message: params.message,
    context: params.context,
  })
}

export const runtimeFallback = ({
  block,
  reason,
  pluginId,
}: {
  block: BlockInstance
  reason: string
  pluginId: string
}): BlockInstance => {
  logStorefrontRuntimeEvent({
    level: 'warn',
    event: frontendDiagnosticsEvents.storefrontRuntime.fallback,
    message: 'Storefront plugin runtime fallback rendered',
    context: {
      pluginId,
      blockType: block.type,
      runtimeMode: block.runtimeMode || null,
      reason,
    },
  })
  return {
    ...block,
    props: {
      ...normalizeStorefrontBlockProps(block.props),
      [STOREFRONT_RUNTIME_ERROR_KEY]: reason,
    },
  }
}
